import { useSelector } from "react-redux";
import { selectCurrentToken } from "../redux-toolkit/features/auth/authSlice";
import jwtDecode from "jwt-decode";

const useAuth = () => {
  const token = useSelector(selectCurrentToken);
  let isAdmin = false;
  let isSuperAdmin = false;
  let isCustomRole = false;
  let level = "";
  let permissions = null;
  let allPermissions = [];

  if (token) {
    const decoded = jwtDecode(token);
    const { _id, permissions, managedCompanies, company } = decoded.userData || {};
    // Default managedCompanies to empty array for backward compatibility
    const userManagedCompanies = managedCompanies || [];
    
     if (permissions) {
       level = 'EMPLOYEE';
       if (permissions.ADMIN) {
         permissions.ADMIN.map((item) => allPermissions.push(item));
         isAdmin = true;
         level = 'ADMIN';
       }
       if (permissions.SUPERADMIN) {
         permissions.SUPERADMIN.map((item) => allPermissions.push(item));
         isSuperAdmin = true;
         level = 'SUPERADMIN';
       }
       if (permissions.CUSTOMROLE) {
         permissions.CUSTOMROLE.map((item) => allPermissions.push(item));
         isCustomRole = true;
         level = 'CUSTOMROLE';
       }
     }

    // Helper function to get all accessible companies (primary + managed)
    const getAccessibleCompanies = () => {
      const accessible = [company];
      if (userManagedCompanies && userManagedCompanies.length > 0) {
        accessible.push(...userManagedCompanies);
      }
      // Remove duplicates
      return [...new Set(accessible)];
    };

    // Helper function to check if user can access a company
    const canAccessCompany = (companyId) => {
      if (!companyId) return false;
      const accessible = getAccessibleCompanies();
      return accessible.some((id) => id === companyId || id?.toString() === companyId?.toString());
    };

    return {
      id: _id,
      level,
      isAdmin,
      isSuperAdmin,
      isCustomRole,
      allPermissions,
      permissions,
      managedCompanies: userManagedCompanies,
      company,
      getAccessibleCompanies,
      canAccessCompany,
    };
  }
  return {
    id: null,
    level: "",
    isAdmin,
    isSuperAdmin,
    isCustomRole,
    allPermissions,
    permissions,
    managedCompanies: [],
    company: null,
    getAccessibleCompanies: () => [],
    canAccessCompany: () => false,
  };
};
export default useAuth;
